var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-2"},[_c('b-card-title',{staticClass:"lead"},[_vm._v(" Activities ")]),_c('calendar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }